import type { Me } from '@/api'

/** Somebody who wants the session each time a page reads it again after changing it. */
export type SessionListener = (me: Me) => void

const listeners = new Set<SessionListener>()

/**
 * The shell keeps its own copy of the signed-in session for the header and the enterprise picker, read once when it
 * mounts. A page that changes what the session says (#2217: the enterprise renamed on the Enterprise page) reads it
 * again and announces the fresh read here, so the shell shows the change without a reload. Answers the call that
 * stops listening.
 */
export function onSessionRead(listener: SessionListener): () => void {
    listeners.add(listener)
    return () => {
        listeners.delete(listener)
    }
}

/** Hands a fresh read of the session to everybody listening. */
export function announceSessionRead(me: Me): void {
    for (const listener of listeners) {
        listener(me)
    }
}
